import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function operationProgressReducer(state = initialState.operationProgress, action) {
    switch (action.type) {
        case types.OPERATION_PROGRESS_UPDATED:
            const newMap = new Map([...state.value]);
            newMap.delete(action.value.parentId);
            newMap.set(action.value.parentId, { percentage: action.value.percentage });
            return Object.assign({}, state, { value: newMap });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/operationProgressReducer.js